var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-space-between--center exact-match-switch"},[_c('h3',{staticClass:"reg"},[_vm._v("Exact match only")]),_c('v-switch',{staticClass:"dark small",attrs:{"inset":"","dense":"","color":"white"},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }